import { PathFile } from './path-file.model';
import { PathQuery } from './path-query.model';
import { environment } from 'src/environments/environment';

export class NavigationPath {
    private directory: string;
    private file: PathFile;
    private query: PathQuery;
    private webserver: string;

    constructor(webserver: string, directory: string, file: PathFile, query: PathQuery) {
        this.webserver = webserver;
        this.directory = directory;
        this.file = file;
        this.query = query;
    }

    public isDifferentDomain(): boolean {
        if (this.webserver && (this.webserver.length > 1)) {
            const ifDomain = this.getDomain(environment.WebServer);
            const pathDomain = this.getDomain(this.webserver);
            return (ifDomain !== pathDomain);
        }
        return false;
    }

    public getDomain(server: string) {
        const urlParts = server.split('//');
        const fullDomain = urlParts[urlParts.length - 1];
        const domainParts = fullDomain.split(':');
        const firstdomain = domainParts[0];
        const domain = firstdomain.replace('/', '');
        return domain;
    }

    get Webserver(): string { return this.webserver; }
    set Webserver(value: string) { this.webserver = value; }

    get Directory(): string { return this.directory; }
    set Directory(value: string) { this.directory = value; }

    get File(): PathFile { return this.file; }
    set File(value: PathFile) { this.file = value; }

    get Query(): PathQuery { return this.query; }
    set Query(value: PathQuery) { this.query = value; }

    // public toJSON() {
    //     const query = JSON.stringify(this.query);
    //     const file = JSON.stringify(this.file);
    //     const json = `${this.directory}/${file}?${query}`;
    //     return json;
    // }

    public toQueryParam(): any {
        let params = { };
        if (this.Query) {
            params = this.Query.toQueryParam();
        }
        return params;
    }

    public toRelativeString(): string {
        const file = (this.file) ? '/' + this.file.toString() : '';
        const path = `/${this.directory}${file}`;
        return path;
    }

    public toString(): string {
        const query = (this.query) ? this.query.toString() : '';
        const file = (this.file) ? '/' + this.file.toString() : '';
        const path = `${this.webserver}/${this.directory}${file}?${query}`;
        return path;
    }
}
